import ActivityType from '../../schema/innerSchema/ActivityType';
import LogNames from '../../schema/telemetry/LogNames';
import TxpDatapoint from '../../schema/configSchema/TxpDatapoint';
import TxpObject from '../../schema/TxpObject';

/**
 * populate the action button dataPoint object
 */
function populateActionButtonDataPoint(activityType: ActivityType, customData?: any): TxpDatapoint;
function populateActionButtonDataPoint(TxpObject: TxpObject): TxpDatapoint;
function populateActionButtonDataPoint(
    activityTypeOrTxpObject: ActivityType | TxpObject,
    customData?: any
) {
    let activityType: ActivityType = null;
    if (typeof activityTypeOrTxpObject === 'number') {
        activityType = activityTypeOrTxpObject;
    } else {
        const txpObject = activityTypeOrTxpObject;
        activityType =
            txpObject && txpObject.txpActivities && txpObject.txpActivities.length > 0
                ? txpObject.txpActivities[0].type
                : null;
    }
    return {
        ...customData,
        [LogNames.activityType]: activityType && activityType.toString(),
    };
}

export default populateActionButtonDataPoint;
